// extracted by mini-css-extract-plugin
export default {"archiveWrapper":"styles_archiveWrapper__ftcxt","count":"styles_count__Jb3xQ","icon":"styles_icon__bErkj","isUnread":"styles_isUnread__+8WuD"};